import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import flowerImg from "../assets/flower.svg";
import rainbowImg from "../assets/cloudRainbow.svg";
import openMouthImg from "../assets/openMouth.svg";
import trophyImg from "../assets/trophyAward.png";
import axiosStrapiInstance from "../axiosStrapi";
import { baseUrl } from "../axiosStrapi";
import CustomGalleryModal from "./custom/CustomGalleryModal";
import Loader from "./custom/Loader";

const contents = [
  "At Mother’s Pride, we believe in providing kids the opportunity to indulge in play-based learning. We allow children to explore and create their own fun. Whether it’s imaginative Role-Play, or building with blocks, or bouncing around in the bouncy castle, we cherish the opportunity to create moments filled with fun, play & adventure.",
  "We treasure these moments where love is in the air and the fun is non-stop! We create experiences that are joyful and full of adventure for our kids. Our Early Education curriculum is one of the best in the country, giving ample time for fun and frolic. This gallery is a testament to the moments of joy that we have created with our little Prideens.",
  "The early years of a child’s life are the most formative, setting the foundation for their future success. Research shows that the first five years are critical for brain development, with 90% of a child’s brain growth happening before they even enter kindergarten. At Mother's Pride, we understand the profound impact that early education has on shaping a child’s cognitive, social, and emotional development. In this post, we’ll explore why investing in early childhood education is one of the best decisions you can make for your child’s lifelong success.",
];

const InteractiveGallery = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tabs, setTabs] = useState([]);
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 1);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  function reArrangeTabs(total, item) {
    const existingCategory = total.find((obj) => obj.title === item?.category);
    if (existingCategory) {
      existingCategory.images.push(item?.image?.url);
    } else {
      total.push({
        title: item?.category,
        images: [item?.image?.url],
        backgroundColor:
          item?.category === "Fun & Adventure"
            ? "#C3DEFF"
            : item?.category === "Kids Gallery"
            ? "rgb(255,207,207)"
            : "rgb(255,249,207)",
        textColor:
          item?.category === "Fun & Adventure"
            ? "#0D4F9E"
            : item?.category === "Kids Gallery"
            ? "#D31C4F"
            : "#FDBE60",
        icon:
          item?.category === "Fun & Adventure"
            ? rainbowImg
            : item?.category === "Kids Gallery"
            ? openMouthImg
            : trophyImg,
        content:item?.category === "Fun & Adventure"
        ? contents[0]
        : item?.category === "Kids Gallery"
        ? contents[1]
        : contents[2],
      });
    }
    return total;
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axiosStrapiInstance.get(
          "/api/galleries?filters[level][eq]=School&populate=image&sort=galleryId:asc"
        );
        const data = response?.data?.data;
        const newData = data?.reduce(reArrangeTabs, []);
        setTabs(newData);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data from Strapi:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div
      style={{
        lineHeight: "1.6",
      }}
      className="text-left font-Lato px-[4%] mt-[2rem] lg:mt-[4rem]"
    >
      <div className="flex font-Lato text-[#D31C4F] flex-row items-center gap-[10px]">
        <p className="font-bold sm:leading-[72px] font-Wonderbar leading-[34px] text-[30px] sm:text-[60px]">
          Our Interactive{" "}
          <span className="font-medium text-2xl sm:text-[45px]">Gallery</span>{" "}
        </p>
        <img src={flowerImg} alt="flower" />
      </div>

      {/* Tabs */}
      <div className="flex justify-between gap-[10px] mb-[20px] flex-wrap mt-[20px]">
        {tabs.map((tab, index) => (
          <div
            key={index}
            onClick={() => setActiveTab(index)}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = tab.backgroundColor)
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor =
                activeTab === index ? tab.backgroundColor : "transparent")
            }
            style={{
              border: "1px solid #E4E4E4",
              backgroundColor:
                activeTab === index ? tab.backgroundColor : "transparent", // Keep active tab highlighted
              color: activeTab === index ? tab.textColor : "#646464",
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flex: 1,
              transition: "background 0.3s ease",
            }}
            className="flex sm:flex-row flex-col lg:rounded-[30px] rounded-md sm:rounded-[20px] sm:mx-[10px] sm:px-4 lg:px-5 py-2 lg:py-[10px]"
          >
            <p className="w-[100px] sm:text-2xl lg:text-3xl"> {tab.title}</p>
            <img
              className="w-[50px] sm:w-[70px] lg:w-[90px]"
              src={tab.icon}
              alt=""
              style={{
                filter: activeTab !== index ? "grayscale(80%)" : "none",
              }}
            />
          </div>
        ))}
      </div>


      {/* Description */}
      <p
        className="sm:text-xl"
        style={{
          marginTop: "2.3rem",
          marginBottom: "2.3rem",
          color: "#383838",
        }}
      >{tabs[activeTab]?.content}</p>
      
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* Images */}
          <CustomGalleryModal
            paddingX={"0%"}
            paddingY={"2%"}
            images={tabs[activeTab]?.images?.map((item) => `${item}`)}
            scroll={window.innerWidth < 450 ? true : false}
          />
        </>
      )}

      <Footer marginX={"6%"} />
    </div>
  );
};

export default InteractiveGallery;
